import { render, staticRenderFns } from "./Intro.vue?vue&type=template&id=56a3431c&scoped=true&"
import script from "./Intro.vue?vue&type=script&lang=js&"
export * from "./Intro.vue?vue&type=script&lang=js&"
import style0 from "./Intro.vue?vue&type=style&index=0&id=56a3431c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a3431c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/nantong-hrpark-prod-mobile-company(微信公众号-企业）/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('56a3431c', component.options)
    } else {
      api.reload('56a3431c', component.options)
    }
    module.hot.accept("./Intro.vue?vue&type=template&id=56a3431c&scoped=true&", function () {
      api.rerender('56a3431c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/shared/Intro.vue"
export default component.exports